import React from 'react';
import { Minus, Plus, ShoppingCart } from 'lucide-react';

export const QuantityPanel = ({ quantity, setQuantity, unitPrice, onAddToCart }) => (
  <div className="w-full max-w-md mt-4 sm:mt-6 p-3 sm:p-5 bg-white rounded-xl shadow-lg border border-gray-100">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-[10px] sm:text-xs text-gray-500 font-medium uppercase tracking-wide">Quantity</p>
        <p className="text-lg sm:text-xl font-bold text-gray-900 mt-0.5 sm:mt-1">{quantity} {quantity === 1 ? 'shirt' : 'shirts'}</p>
      </div>

      <div className="flex items-center gap-2">
        <button
          data-testid="quantity-minus-btn"
          onClick={() => setQuantity(Math.max(1, quantity - 1))}
          disabled={quantity <= 1}
          className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center transition-all ${
            quantity <= 1
              ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200 active:scale-95'
          }`}
        >
          <Minus className="w-3 h-3 sm:w-4 sm:h-4" />
        </button>

        <span className="w-8 sm:w-10 text-center text-lg sm:text-xl font-bold text-gray-900">{quantity}</span>

        <button
          data-testid="quantity-plus-btn"
          onClick={() => setQuantity(quantity + 1)}
          className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary text-white flex items-center justify-center hover:bg-primary/90 active:scale-95 shadow-md"
        >
          <Plus className="w-3 h-3 sm:w-4 sm:h-4" />
        </button>
      </div>
    </div>

    <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-100">
      <div className="flex justify-between items-center">
        <span className="text-xs sm:text-sm text-gray-500">${unitPrice.toFixed(2)} × {quantity}</span>
        <span className="text-xl sm:text-2xl font-black text-primary">${(unitPrice * quantity).toFixed(2)}</span>
      </div>
    </div>

    <button
      data-testid="add-to-cart-btn-preview"
      onClick={onAddToCart}
      className="w-full mt-3 sm:mt-4 py-2.5 sm:py-3 px-4 bg-gradient-to-r from-primary to-indigo-600 hover:from-primary/90 hover:to-indigo-600/90 text-white font-bold text-sm sm:text-base rounded-xl shadow-lg shadow-primary/25 transition-all duration-200 hover:shadow-xl active:scale-[0.98] flex items-center justify-center gap-2"
    >
      <ShoppingCart className="w-4 h-4 sm:w-5 sm:h-5" />
      Add to Cart · ${(unitPrice * quantity).toFixed(2)}
    </button>

    <p className="mt-2 sm:mt-3 text-[10px] sm:text-xs text-center text-gray-500">
      Remember to add to cart before changing design
    </p>
  </div>
);

export default QuantityPanel;
